import { useState, useEffect, useCallback } from "react";
import Header from "components/Headers/chatHeader.js";
import { CMM } from '../../Lib/Cmm.js';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { fetchAxios, postAxios, postNoauth } from 'Lib/GetAxios';
import { etcStore } from 'store/etcStore';

import {
  Card,
  CardHeader,
  CardBody,
  Container,
} from "reactstrap";


const ChatBot = (props) => {

  const [uuid, setUuid] = useState('');

  //데이터 가져오기
  useEffect(() => {

    lodeData();

  }, []);

  //데이터 받아오기
  const lodeData = useCallback(() => {

    fetchAxios(`${CMM.SERVER_URL_API}/admin/get_user_idx`,
      {})
      .then((res) => {
        if (res != 'ERROR') {
          // console.log(res);
          setUuid(res[0].u_uuid);

        }
      })
      .catch((e) => {
        console.log('error::', e.message)
      })
  }, [uuid]);



  const script =
    ` <script>
		var w = window;
		var d = window.document;

		var chatDiv = d.createElement('div');
		chatDiv.id = "MyChstBotModal";
		chatDiv.className = "chatbotmodal";

		var chatDivSub = d.createElement('div');
		chatDivSub.id = "reactAppContainer";
		chatDiv.appendChild(chatDivSub);

		var btnDiv = d.createElement('div');
		btnDiv.id = "chat-widget";
		btnDiv.className = "box";

		var closebtnDiv = d.createElement('div');
		closebtnDiv.id = "mobile-chat-widget-close";
		closebtnDiv.className = "close_box";

		var btnImg = d.createElement('img');
		btnImg.id = "profile_img";
		btnImg.className = "profile";
		btnImg.src = "https://chatbotapi.industrybook.co.kr/files/f3605523-653a-4ddd-9f65-dabfb41aa6d1_1712194973931.png"
		btnDiv.appendChild(btnImg);

		var closebtnImg = d.createElement('img');
		closebtnImg.id = "close_img";
		closebtnImg.className = "profile";
		closebtnImg.src = "https://chatbotapi.industrybook.co.kr/files/dc740324-1574-4cf5-9889-a65799f4749c_1712557963910.png"
		closebtnDiv.appendChild(closebtnImg);

		d.body.appendChild(chatDiv);
		d.body.appendChild(btnDiv);
		d.body.appendChild(closebtnDiv);

		const chatWidget = document.getElementById('chat-widget');
		const mobilechatWidget = document.getElementById('mobile-chat-widget-close');
		const chatbotmodal = document.getElementById('MyChstBotModal');
		let isModalOpen = false;
		const reactAppContainer = document.getElementById('reactAppContainer');
		const iframe = document.createElement('iframe');

		iframe.src = 'https://chatbot.industrybook.co.kr/chatbot/${uuid}';
		iframe.id = 'iframe';
		iframe.width = '350';
		iframe.height = '500';
		iframe.style.borderRadius = '20px';
		iframe.style.border = '1px solid rgba(189, 189, 189, 0.5)';

		reactAppContainer.appendChild(iframe);


		function resizeIframe() {

			if (window.innerHeight < 650) {
				iframe.style.height = (window.innerHeight - 100) + 'px'; // 높이를 설정합니다
				chatbotmodal.style.bottom = '50px';
				chatbotmodal.style.right = '150px';
				chatbotmodal.style.margin = '0px';
			} else {

				iframe.style.height = 500;
				chatbotmodal.style.bottom = '120px';
				chatbotmodal.style.right = '30px';
				chatbotmodal.style.margin = '20px';
			}
		}

		function autoResizeIframe() {
			iframe.addEventListener('load', resizeIframe);
		}

		window.addEventListener('resize', resizeIframe);

		chatWidget.addEventListener('click', () => {
			const image = document.getElementById('profile_img');

			if (!isModalOpen) {

				chatbotmodal.style.display = 'block';
				isModalOpen = true;
				image.src = "https://chatbotapi.industrybook.co.kr/files/dc740324-1574-4cf5-9889-a65799f4749c_1712557963910.png"

				if (window.innerWidth <= 450) {
					// 모바일용 모달 처리

					d.body.style.overflow = 'hidden';
					d.body.style.height = '100%';

					iframe.style.width = window.innerWidth + 'px';
					iframe.style.height = window.innerHeight + 'px';
					mobilechatWidget.style.display = 'block';
					chatbotmodal.style.bottom = '0px';
					chatbotmodal.style.right = '0px';
					chatbotmodal.style.margin = '0px';
					iframe.style.borderRadius = '0px';
					chatbotmodal.style.height = '100dvh';
				} else {
					if (window.innerHeight < 660) {

						iframe.style.height = (window.innerHeight - 100) + 'px';
						chatbotmodal.style.height = '100dvh';

						chatbotmodal.style.top = '50px';
						chatbotmodal.style.right = '150px';
						chatbotmodal.style.margin = '0px';
					}
				}
			} else {

				d.body.style.overflow = '';
				d.body.style.height = '';

				chatbotmodal.style.display = 'none';
				isModalOpen = false;
				image.src = "https://chatbotapi.industrybook.co.kr/files/f3605523-653a-4ddd-9f65-dabfb41aa6d1_1712194973931.png"
			}
		});

		mobilechatWidget.addEventListener('click', () => {

			if (isModalOpen) {
				d.body.style.overflow = '';
				d.body.style.height = '';

				const image = document.getElementById('profile_img');

				mobilechatWidget.style.display = 'none';
				chatbotmodal.style.display = 'none';
				isModalOpen = false;
				image.src = "https://chatbotapi.industrybook.co.kr/files/f3605523-653a-4ddd-9f65-dabfb41aa6d1_1712194973931.png"
			}
		});

		/*스크롤 방지*/
		function scrollDisable() {
			$('html, body').addClass('hidden');
		}
		function scrollAble() {
			$('html, body').removeClass('hidden');
		}

		function scrollDisable() {
			$('body').addClass('scrollDisable').on('scroll touchmove mousewheel', function (e) {
				e.preventDefault();
			});
		}
		function scrollAble() {
			$('body').removeClass('scrollDisable').off('scroll touchmove mousewheel');
		}
		/*스크롤 방지*/

		const cssString = \`

	/*스크롤 방지*/

	.hidden {
		height:100%; 
		min-height:100%; 
		overflow:hidden !important; 
		touch-action:none;
	}
	/*스크롤 방지*/

	.box {
		width: 70px;
		height: 70px;
		border-radius: 50%;
		overflow: hidden;
		z-index : 99;
	}

	.close_box {
		width: 50px;
		height: 50px;
		border-radius: 50%;
		z-index : 100000;
		overflow: hidden;
	}

	.profile {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	#mobile-chat-widget-close {
		display : none;
		position: fixed;
		top: 5px;
		right: 10px;
		color: #fff;
		padding: 10px;
		cursor: pointer;
	}

	#chat-widget {
		position: fixed;
		bottom: 50px;
		right: 50px;
		/* background-color: #007bff; */
		color: #fff;
		padding: 10px;
		cursor: pointer;
	}

	.chatbotmodal {
		min-height: 200px;
		display : none;
		transition: opacity 0.3s;
		border-radius: 20px;
		position: fixed;
		bottom: 120px;
		right: 30px;
		margin: 20px;
		z-index : 10000;
		/* box-shadow: 5px 10px 5px rgba(99, 99, 99, 0.5); */
	}
	\`;

		const styleElement = document.createElement('style');
		styleElement.textContent = cssString;
		document.head.appendChild(styleElement);
	</script> `;


  const handleCopyClipBoard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);

      //토스트 메시지
      toast.success('클립보드에 링크가 복사되었습니다.', {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } catch (e) {
      //토스트 메시지
      toast.error('복사에 실패하였습니다.', {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  return (
    <>
      <Header />
      <ToastContainer
        position="bottom-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="light"
      />
      {/* Page content */}
      <Container className="mt--7 position-absolute start-0" fluid style={{ maxWidth: '1300px', }}>
        <Card className="bg-white">
          <CardHeader className="bg-white">
            <div className="font-weight-bold d-none d-sm-block"
              style={{ lineHeight: 1.2 }}>
              <h1 className="d-inline-block"
                style={{ color: 'black' }}>
                시작하기</h1>
            </div>
            <div className="font-weight-bold d-sm-none "
              style={{ lineHeight: 1.2 }}>
              <h2 className="d-inline-block"
                style={{ color: 'black' }}>
                시작하기</h2>
            </div>
          </CardHeader>
          <CardBody className="p-0 bg-white ">
            <div className="mx-5 my-4">
              {/* 1단계 */}
              <div className="mb-5">
                <div className=" text-dark text-lg font-weight-bold ">
                  1. 홈페이지 연결</div>
                <div className="my-2 mx-3"
                  style={{ color: '#727272' }}>
                  홈페이지 바디 영역 하단에 아래 코드를 붙여넣은 후 웹페이지를 재실행하면 박대리 챗봇이 바로 적용됩니다.
                </div>
                <div className=" font-weight-bold border rounded-lg mx-5 my-3 "
                  style={{ color: '#404040', backgroundColor: '#e6e6e6' }}>
                  <div className=" px-3 py-2 rounded-lg mt-1 overflow-auto"
                    // style={{ height: '280px' }}>
                    style={{ height: '25vh', color: '#444444' }}>
                    <div>
                      {script}
                    </div>

                  </div>
                </div>
                <div className=" mt-2 ml-2 text-right  mr-5"
                  onClick={() => handleCopyClipBoard(script)}
                  style={{ cursor: "pointer" }}>
                  <span className="p-2 px-3 rounded-sm font-weight-bold text-sm  "
                    style={{ backgroundColor: '#444444', color: '#E6E6E6' }}>
                    복사하기
                  </span>
                </div>
              </div>
              {/* 2단계 */}
              <div className="mb-5">
                <div className=" text-dark text-lg font-weight-bold ">
                  2. 챗봇 프로필 설정</div>
                <div className=" mx-3 mt-2  "
                  style={{ color: '#5686E1' }}>
                  <a href={`${CMM.SERVER_URL} /admin/chatbot - profile`}>
                    <svg className="mr-1" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.75813 3H0V5H9.75813V8L13 4L9.75813 0V3Z" fill="#5686E1" />
                    </svg>
                    프로필 설정 바로가기</a></div>
                <div className="my-2 mx-3"
                  style={{ color: '#727272' }}>
                  회사 로고와 테마 색상으로 박대리를 꾸미고 멋진 소개 문구를 작성해보세요.
                </div>
                <img className=" border rounded-lg mb-3 mx-3" src="img/chatbot_1.png" width="800" height="full" />
                <img className=" border rounded-lg mt-3 mx-3" src="img/chatbot_2.png" width="800" height="full" />
              </div>

              {/* 3단계 */}
              <div className="mb-5">
                <div className=" text-dark text-lg font-weight-bold ">
                  3. 키워드 추가 및 수정</div>
                <div className=" mx-3 mt-2  "
                  style={{ color: '#5686E1' }}>
                  <a href={`${CMM.SERVER_URL} /admin/keyword`}>
                    <svg className="mr-1" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.75813 3H0V5H9.75813V8L13 4L9.75813 0V3Z" fill="#5686E1" />
                    </svg>
                    키워드 관리 바로가기</a></div>
                <div className="my-2 mx-3"
                  style={{ color: '#727272' }}>
                  이제 막 적용한 박대리는 갓난 아이에요. 어른처럼 똑 부러지게 고객을 대응할 수 있도록 박대리에게 중요한 키워드를 알려주세요.
                  키워드는 고객의 질문 의도를 더 빨리 알아차리는데 큰 도움이 됩니다.
                  다양한 유형으로 키워드를 구분해서 알려주면 박대리는 더 구체적이고 정확한 답변을 할 수 있게 됩니다.

                  <div className="mt-3 font-weight-bold"><span className="">tip!</span> 고유명사를 활용해 키워드로 체크할 수 없는 제품명, 영단어 등을 설정할 수 있습니다.</div>
                </div>
                <img className=" border rounded-lg mb-3 mx-3" src="img/kwd_1.png" width="800" height="full" />
                <img className=" border rounded-lg my-3 mx-3" src="img/kwd_2.png" width="800" height="full" />
              </div>

              {/* 4단계 */}
              <div className="mb-5">
                <div className=" text-dark text-lg font-weight-bold ">
                  4. 답변 추가 및 수정</div>
                <div className=" mx-3 mt-2  "
                  style={{ color: '#5686E1' }}>
                  <a href={`${CMM.SERVER_URL} /admin/answer`}>
                    <svg className="mr-1" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.75813 3H0V5H9.75813V8L13 4L9.75813 0V3Z" fill="#5686E1" />
                    </svg>
                    답변 관리 바로가기</a></div>
                <div className="my-2 mx-3"
                  style={{ color: '#727272' }}>
                  여기까지 하셨다면 우리 박대리는 고객의 질문을 알아들을 수 있게 됐습니다.
                  박대리가 다양한 유형의 키워드를 인식했을 때 어떤 내용을 답해야 할지 내용을 알려주세요.
                  동일한 키워드라도 박대리는 질문 의도에 따라서 다른 답변을 할 수 있으니 질문 키워드 유형과 비슷하게 답변을 등록해주시면 더 만족스러운 정보를 제공할 수 있습니다.
                  답변과 관련한 URL 링크도 함께 알려주시면 박대리는 고객에게 답변과 함께 링크를 추가하여 제공할 수 있습니다.
                </div>
                <img className=" border rounded-lg mb-3 mx-3" src="img/ans.png" width="800" height="full" />
              </div>

              {/* 5단계 */}
              <div className="mb-5">
                <div className=" text-dark text-lg font-weight-bold ">
                  5. 채팅 테스트</div>
                <div className=" mx-3 mt-2 "
                  style={{ color: '#5686E1' }}>
                  <a href={`${CMM.SERVER_URL} /admin/chatBorder`}>
                    <svg className="mr-1" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.75813 3H0V5H9.75813V8L13 4L9.75813 0V3Z" fill="#5686E1" />
                    </svg>
                    채팅 바로가기</a></div>
                <div className="my-2 mx-3"
                  style={{ color: '#727272' }}>
                  박대리는 질문과 답변을 많이 할수록 더 똑똑해지는 인공지능입니다. 그래도 직접 고객처럼 여러 질문을 해보세요.
                  그리고 박대리가 응대한 채팅방 목록에서 실제 고객을 어떻게 응대했는지 직접 확인하실 수도 있습니다.
                  응대 내용을 참고해서 질문과 답변을 더 공부시키면 박대리는 더 똑똑한 성능으로 성장할 수 있습니다.
                </div>
                <img className=" border rounded-lg mb-3 mx-3" src="img/chat_1.png" width="800" height="full" />
                <img className=" border rounded-lg mb-3 mx-3" src="img/chat_2.png" width="800" height="full" />
              </div>
            </div>
            <div className=""
              style={{ height: '200px' }}></div>
          </CardBody>
        </Card>
      </Container >
    </>
  );
};

export default ChatBot;
